// Action Constants
import { OrgMedia } from "../../constants/action-constants/org/OrgMediaActionConstants";

// get Org Media Info
export const getOrgMediaInfo = (mediaId, orgId) => ({
  type: OrgMedia.GET_ORG_MEDIA_INFO,
  payload: { mediaId, orgId },
});

// add Org Media Images
export const addOrgMediaImages = (orgId, mediaId, files) => ({
  type: OrgMedia.ADD_ORG_MEDIA_IMAGES_SUCCESS,
  payload: { orgId, mediaId, files },
});

export const downloadOrgMediaPdfReport = (
  orgId,
  mediaId,
  radius,
  isSentViaEmail,
  emailIds
) => ({
  type: OrgMedia.DOWNLOAD_ORG_MEDIA_PDF_REPORT,
  payload: { orgId, mediaId, radius, isSentViaEmail, emailIds },
});

export const resetOrgMediaPdfReport = () => ({
  type: OrgMedia.RESET_ORG_MEDIA_PDF_REPORT,
});

// Refresh Org All Media Info
export const refreshOrgAllMediaInfo = (orgId) => ({
  type: OrgMedia.REFRESH_ORG_ALL_MEDIA_INFO,
  payload: { orgId },
});
